import React, { useEffect, useState, useMemo } from 'react';
import { useAuth } from '../../utils/utilities';
import { currencyFormat } from '../../utils/utilities';
import IconCheck from '../../assets/images/icon_checkbox.svg';

function SharesAccount() {
    const { userData } = useAuth();
    const [loanDetails, setLoanDetails] = useState([]);

    // useEffect to set loan details when userData changes
    useEffect(() => {
        if (userData?.LoanAccountDetails) {
            setLoanDetails(userData.LoanAccountDetails);
        }
    }, [userData]);

        const allSharesBalancesDraft = useMemo(() => {
            return loanDetails.reduce((acc, loan) => {

                // Step 1: Parse balance safely
                const balance = parseFloat(loan["Balance"] || 0);

                // Step 2: Normalize balance type
                const balanceType = (loan["Balance Type"] || "").toLowerCase();
                let originalName = loan["Balance Type"];

                // Step 3: Normalize Shares Balance name
                if (originalName === 'Shares Balance' || originalName === 'Total Shares Balance') {
                    originalName = 'Total Shares Balance';
                    acc.__hasShares = true;
                }

                // Step 4: If this loan has a shares type, accumulate it
                if (balanceType.includes("shares")) {
                    // Mark that shares balance exists
                    if (!acc[originalName]) {
                        acc[originalName] = 0;
                    }
                    acc[originalName] += balance;
                }
                return acc;
            }, {});
        }, [loanDetails]);

        const allSharesBalances = useMemo(() => {
        const result = allSharesBalancesDraft;

        // Step 5: If no shares balance was found, use Total Shares Balance
        if (!result.__hasShares) {
            loanDetails.forEach((loan) => {
                if (loan["Total Shares Balance"] !== 'NULL') {
                    if (!result['Total Shares Balance']) {
                        result['Total Shares Balance'] = 0;
                    }
                    result['Total Shares Balance'] += parseFloat(
                        loan["Total Shares Balance"] || 0
                    );
                }
            });
        }

        // Step 6: Cleanup helper flag
        delete result.__hasShares;
        return result;
    }, [allSharesBalancesDraft, loanDetails]);

    // const sharesBalancesGBP = useMemo(() => {
    //     return loanDetails.reduce((acc, loan) => {
    //         const balance = parseFloat(loan["Balance"] || 0);
    //         switch (loan["Balance Type"]) {
    //             case "Shares Balance (GBP)":
    //                 acc.balance += balance;
    //                 break;
    //             default:
    //                 break;
    //         }
    //         return acc;
    //     }, {
    //         balance: 0,
    //     });
    // }, [loanDetails]);

    // Check if balance is valid
    const isValidBalance = (balance) => !isNaN(balance) && balance !== 0;

    const hassharesDetails = useMemo(() => {
        return Object.values(allSharesBalances).some(isValidBalance);
    }, [allSharesBalances]);

    // Early return if userData is not available
    if (!userData) {
        return <p>Loading...</p>;
    }

    const renderSharesInfo = () => {

        // allSharesBalances
        const sharesBalanceInfo = Object.keys(allSharesBalances).some(key => isValidBalance(allSharesBalances[key])) && (
                <>

                    {/* Step 1: Print Total Shares Balance first */}
                    {isValidBalance(allSharesBalances["Total Shares Balance"]) && (
                        <div className="profile-form" key={'Total Shares Balance'.toLowerCase().trim().replaceAll(' ', '-')}>
                            <ul>
                                <li>
                                    <label>Balance Type:</label>
                                    <h4>Total Shares Balance</h4>
                                </li>
                                <li>
                                    <label>Balance:</label>
                                    <h4>{currencyFormat(allSharesBalances["Total Shares Balance"])}</h4>
                                </li>
                            </ul>
                        </div>
                    )}

                    {/* Step 2: Print all other balances */}
                    {Object.entries(allSharesBalances)
                        .filter(([name]) => name !== "Total Shares Balance")
                        .map(([name, value]) =>
                            isValidBalance(value) ? (
                                <div className="profile-form" key={name.toLowerCase().trim().replaceAll(' ', '-')}>
                                    <ul>
                                        <li>
                                            <label>Balance Type:</label>
                                            <h4>{name}</h4>
                                        </li>
                                        <li>
                                            <label>Balance:</label>
                                            <h4>{currencyFormat(value)}</h4>
                                        </li>
                                    </ul>
                                </div>
                            ) : null
                        )}
                </>
            );


        // const sharesBalanceInfo = isValidBalance(sharesBalances) && (
        //     <div className='profile-form'>
        //         <ul>
        //             <li>
        //                 <label>Balance Type:</label>
        //                 <h4>Shares Balance</h4>
        //             </li>
        //             <li>
        //                 <label>Balance:</label>
        //                 <h4>{currencyFormat(sharesBalances)}</h4>
        //             </li>
        //         </ul>
        //     </div>
        // );

    
        // const sharesBalanceGBPInfo = isValidBalance(sharesBalancesGBP.balance) && (
        //     <div className='profile-form'>
        //         <ul>
        //             <li>
        //                 <label>Balance Type:</label>
        //                 <h4>Shares Balance (GBP)</h4>
        //             </li>
        //             <li>
        //                 <label>Balance:</label>
        //                 <h4>{currencyFormat(sharesBalancesGBP.balance, 'GBP')}</h4>
        //             </li>
        //         </ul>
        //     </div>
        // );
    
        return (
            <>
                {sharesBalanceInfo}
            </>
        );
    };
    

    // Helper function to render no shares info
    const renderNoSharesInfo = () => (
        <div className='no-shares'>
            <p>Open a Shares Account with us today to begin your Investment Journey. Here are the options available to you:</p>
            <div className='profile-form'>
                <ul className='no-shares-list'>
                    {renderShareOption('One Share: (min)', 10.00)}
                    {renderShareOption('Executive Five Shares:', 50.00)}
                    {renderShareOption('Monthly Saving (min):', 10.00)}
                    {renderShareOption('Platinum Ten Shares:', 100.00)}
                    <li>
                        <label>
                            <img src={IconCheck} alt='Checked icon' />
                            <span>Monthly Admin Fee: <strong>{currencyFormat(1.00)}</strong></span>
                        </label>
                        <h4 className='anual-fee'>{currencyFormat(12)} per annum</h4>
                    </li>
                </ul>
            </div>
            <div className='profile-form'>
                <div className="women-wealth">
                    <h3>Once off shares purchase women of wealth</h3>
                </div>
                <ul className='no-shares-list'>
                    {renderShareOption('200 Shares:', 2000)}
                    {renderShareOption('500 Shares:', 5000)}
                </ul>
            </div>
        </div>
    );

    const renderShareOption = (label, amount) => (
        <li key={label}>
            <label>
                <img src={IconCheck} alt='Checked icon' />
                <span>{label} <strong>{currencyFormat(amount)}</strong></span>
            </label>
        </li>
    );

    return (
        <section className='profile-page'>
            <div className='account-wrapper'>
                <div className='profile-inr shares-page menuBar-scroll bg-gradient'>
                    <div className='profile-dtl'>
                        <h3 className='inr-title'>Shares Account Information</h3>
                        {hassharesDetails ? renderSharesInfo() : renderNoSharesInfo()}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SharesAccount;
